module.exports = __webpack_public_path__ + "static/media/tip.0ce65d7b.gif";